import { render, staticRenderFns } from "./CustomerManagementModal.vue?vue&type=template&id=0c0e28b5&scoped=true"
import script from "./CustomerManagementModal.vue?vue&type=script&lang=js"
export * from "./CustomerManagementModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagementModal.vue?vue&type=style&index=0&id=0c0e28b5&prod&lang=css"
import style1 from "./CustomerManagementModal.vue?vue&type=style&index=1&id=0c0e28b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e28b5",
  null
  
)

export default component.exports